import { memo } from 'react';

import classes from './feature-card.module.scss';

interface IFeatureCardProps {
  title: string;
  text: string;
  icon: string;
}

function FeatureCard({ title, text, icon }: IFeatureCardProps) {
  return (
    <div className={classes.card}>
      <div className={classes.textContainer}>
        <h3 className={classes.title}>{title}</h3>
        <p>{text}</p>
      </div>
      <div className={classes.icon}>
        <img src={icon} alt="" />
      </div>
    </div>
  );
}

export default memo(FeatureCard);
